exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2 {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n  h2 .load {\n    margin-left: 24px;\n    width: 24px;\n    height: 24px; }\n\n.page-buttons {\n  margin-top: 15px; }\n  .page-buttons .previous {\n    background-color: #f1f1f1;\n    color: #0071aa; }\n  .page-buttons .next {\n    background-color: #0071aa;\n    color: white; }\n  .page-buttons .round {\n    border-radius: 50%; }\n  .page-buttons .btn:hover {\n    background-color: #ddd;\n    color: black; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/recon-history/recon-history.component.scss
// module id = ../../../../../src/app/views/daily-recon/recon-history/recon-history.component.scss
// module chunks = main